class PeggellMobileMenu {
  constructor() {
    this.drawer = document.querySelector('.header-wrapper--peggell header-drawer');
    if (!this.drawer) return;

    this.details = this.drawer.querySelector('#Details-menu-drawer-container');
    this.summary = this.details?.querySelector(':scope > summary');
    this.panel = this.drawer.querySelector('.menu-drawer--peggell');

    this.panel?.addEventListener('click', (event) => {
      const closeBtn = event.target.closest('[data-peggell-menu-close]');
      if (closeBtn) {
        event.preventDefault();
        event.stopPropagation();
        this.closeDrawer();
      }
    });

    // Capture phase so MenuDrawer button handlers do not steal the click
    this.panel
      ?.querySelectorAll(
        '.peggell-mobile-menu__search-trigger, [data-peggell-menu-search]'
      )
      .forEach((btn) => {
        btn.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.closeDrawerAndOpenSearch();
          },
          true
        );
      });

    // When search closes, clear any leftover menu overlay / expanded state
    document.querySelectorAll('details-modal.peggell-search').forEach((modal) => {
      const details = modal.querySelector('details');
      if (!details || details.dataset.peggellMenuSync === 'true') return;
      details.dataset.peggellMenuSync = 'true';
      details.addEventListener('toggle', () => {
        if (!details.hasAttribute('open')) this.resetMenuOverlayState();
      });
    });
  }

  resetMenuOverlayState() {
    this.summary?.setAttribute('aria-expanded', 'false');
    this.details?.classList.remove('menu-opening');
    this.details?.removeAttribute('open');
    this.drawer.header?.classList.remove('menu-open');
    document.querySelector('.section-header')?.classList.remove('menu-open');

    const breakpoint = this.drawer.dataset?.breakpoint;
    if (breakpoint) {
      document.body.classList.remove(`overflow-hidden-${breakpoint}`);
    }
  }

  closeDrawer() {
    const isOpen =
      this.details?.hasAttribute('open') ||
      this.summary?.getAttribute('aria-expanded') === 'true';

    if (!isOpen) {
      this.resetMenuOverlayState();
      return;
    }

    if (typeof this.drawer.closeMenuDrawer === 'function' && this.summary) {
      this.drawer.closeMenuDrawer(new Event('click'), this.summary);
    } else {
      this.summary?.click();
    }

    // Dawn historically left aria-expanded true; clear overlay immediately
    this.resetMenuOverlayState();
  }

  openSearchModal() {
    const searchModal =
      document.querySelector('details-modal.header__search--peggell-mobile') ||
      document.querySelector('.header__peggell-start details-modal.header__search') ||
      document.querySelector('details-modal.peggell-search');

    if (!searchModal) return;

    if (typeof searchModal.isOpen === 'function' && searchModal.isOpen()) {
      const input = searchModal.querySelector('input[type="search"]');
      input?.focus();
      return;
    }

    if (typeof searchModal.open === 'function') {
      const summary = searchModal.querySelector('summary');
      if (summary) {
        searchModal.open({ target: summary });
        return;
      }
    }

    searchModal.querySelector('summary')?.click();
  }

  closeDrawerAndOpenSearch() {
    this.closeDrawer();

    // Wait for drawer close animation / overflow class cleanup, then open search
    window.setTimeout(() => {
      this.resetMenuOverlayState();
      this.openSearchModal();
    }, 320);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new PeggellMobileMenu());
} else {
  new PeggellMobileMenu();
}
